import { default as deserialize } from 'app/utils/deserialize'
import { create, fetch } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

export default {
  namespaced: true,

  state: {},

  mutations: {
    resetState: (state) => state
  },

  actions: {
    async retrieveStripeCheckoutSession(_state, sessionId) {
      try {
        const response = await fetch({
          url: `/api/checkout/session/${sessionId}`,
          type: 'checkout-session'
        })

        return await deserialize(response.data)
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async requestStripeCheckout(_state, data) {
      try {
        const response = await create({
          url: '/api/checkout/session',
          type: 'checkout-session',
          data: data
        })

        return await deserialize(response.data)
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
